import { isMobile } from './isMobile';
import { isMobileOnly } from './isMobileOnly';
import { isTablet } from './isTablet';
import { isMobileSafari } from './isMobileSafari';
import { isChrome } from './isChrome';
import { isFirefox } from './isFirefox';
import { isTargetOs } from './isTargetOs';

const isWindows = () => isTargetOs('Windows');
const isIOS = () => isTargetOs('iOS') || isTargetOs('iPhone OS');
const isMacOs = () => !isTablet() && !isIOS() && isTargetOs('Mac OS');
const isAndroid = () => isTargetOs('Android');

export { isChrome, isFirefox, isTablet, isMacOs, isIOS, isWindows, isMobile, isMobileOnly, isMobileSafari, isAndroid };
